import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigAssetLoaderService, SearchResult } from '@icullen/api/shared';
import { SearchInput } from '../../model/search-input.model';
import { Observable } from 'rxjs';
import { CaseSearchInput } from '../../model/case-search-input.model';
import { CaseSearchResult } from '../../model/case-search-result.model';

@Injectable({
  providedIn: 'root'
})
export class SearchApiService {

  SEARCH_API_BASE_URL : string;

  constructor(private httpClient: HttpClient,
    private configService : ConfigAssetLoaderService) {
      this.SEARCH_API_BASE_URL= configService.getConfig().apiBaseUrl+'site/documents/';
  }

  searchDocuments(searchInput: SearchInput): Observable<SearchResult> {
    return this.httpClient.post<SearchResult>(this.SEARCH_API_BASE_URL+'search',searchInput)
  }

  searchCaseDocuments(searchInput: CaseSearchInput): Observable<CaseSearchResult> {
    return this.httpClient.post<CaseSearchResult>(this.SEARCH_API_BASE_URL+'case/search',searchInput)
  }

}
